module.exports = __webpack_public_path__ + "img/second_wave_top.84fd2259.svg";